import { Component } from '@angular/core';
import { RiskConceptsComponent } from '../risk-concepts/risk-concepts.component';
@Component({selector:'app-hedge-roll',standalone:true,imports:[RiskConceptsComponent],template:'<app-risk-concepts [page]="7"></app-risk-concepts>'})
export class HedgeRollComponent {}
